export default {
  setFeederTypes(state, payload) {
    state.feederTypes = payload;
  },
  setSocialMediaProfileInfo(state, payload) {
    state.socialMediaProfileInfo = payload;
  },
  setUserFeedHistory(state, payload) {
    state.userFeedHistory = payload;
  },
  setOperationFeederNotes(state, payload) {
    state.operationFeederNotes = payload;
  },
  putFeederGender(state, payload) {
    state.socialMediaProfileInfo.gender = payload.gender;
  },
  putFeederOperationType(state, payload) {
    state.socialMediaProfileInfo.OperationFeederTypeId = payload.feederTypeId;
  }
};
